import { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useEffect, useState } from "react";

export default function useAccountEnhanced() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const [loading, setLoading] = useState(true);
  const [me, setMe] = useState<null | any>(null);

  useEffect(() => {
    async function getAccountData() {
      const aquireTokenSilentResult = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: account,
        extraQueryParameters: {
          claims: JSON.stringify({ id_token: { roles: null } }),
        },
      });

      const test = await axios.get("https://graph.microsoft.com/v1.0/me?$select=employeeId", {
        headers: {
          Authorization: `Bearer ${aquireTokenSilentResult.accessToken}`,
        },
      });

      setLoading(false);
      setMe(test.data);
    }

    getAccountData();
  }, []);

  return {
    loading,
    account,
    me: {
      employeeCode: me?.employeeId ?? null,
    },
  };
}

export type EnhancedAccount = {
    loading: boolean;
    account: AccountInfo;
    me: {
        employeeCode: string | null;
    };
};
